import React from 'react'
import { Alert, Typography } from '@mui/material'
import { useAdminData } from './shared'

export default function NotificationDeliveryNotice({ compact = false }) {
  const { data, error } = useAdminData('/admin/notifications/status')
  const message = error ? 'Notification delivery status is unavailable.'
    : data?.deliveryEnabled ? 'Automatic notification delivery is enabled. Provider acceptance does not confirm inbox delivery.'
      : 'Automatic notification delivery is off. Events remain queued until activation or an approved replay.'
  return compact ? <Typography variant="caption" color="text.secondary" display="block" mt={2}>{message}</Typography>
    : <Alert severity={data?.deliveryEnabled ? 'success' : 'info'}>{message}</Alert>
}
